<template>
  <button
    class="p-1.5 w-7.5 h-7.5 rounded-lg border border-gray-200"
    :disabled="isReadonly"
    @click.stop="emit('toggleFavorite')"
  >
    <StarIcon
      class="w-4 h-4 stroke-1.5"
      :class="[
        study.isFavorite
          ? 'fill-amber-400 stroke-amber-400'
          : 'fill-transparent stroke-mid-neutral-500',
      ]"
    />
  </button>
</template>
<script lang="ts" setup>
import StarIcon from "@app/components/Icons/StarIcon.vue";
import { ReviewItem } from "@core/domain/models/reviewItem.model";

defineProps<{ study: ReviewItem; isReadonly: boolean }>();

const emit = defineEmits<(e: "toggleFavorite") => void>();
</script>
